import { Fact } from '@/modules/projects/components/Workbench/Fact'

// Red like the missing months on the map, so the eye joins the count to the cells.
export const Missing = ({ missing }: { missing: number }) =>
  missing > 0 ? (
    <Fact label="Missing">
      <span className="font-medium tabular-nums text-red-600">
        {missing.toLocaleString()} {missing === 1 ? 'month' : 'months'}
      </span>
    </Fact>
  ) : null
